import React from "react";
import { Card, CardBody, Heading, Text, Circle, Badge } from "@chakra-ui/react";
import currencySymbolMap from "currency-symbol-map";
import { CheckCircleIcon } from "@chakra-ui/icons";

interface PremiumBlockProps {
  heading: string;
  price: string;
  isFreeTrial: boolean;
  freeTrialDays: number;
  currency: string;
  onClick: () => void;
  selected?: boolean;
}

const PremiumBlock: React.FC<PremiumBlockProps> = ({
  heading,
  price,
  currency,
  onClick,
  selected,
  isFreeTrial,
  freeTrialDays,
}) => {
  const getCurrencySymbol = (currencyCode: string) => {
    return currencySymbolMap(currencyCode) || "$";
  };

  return (
    <Card
      direction={"row"}
      align={"start"}
      rounded={"lg"}
      shadow={"lg"}
      p={4}
      gap={2}
      width={"500px"}
      height={"86px"}
      bg={selected ? "#e6f0f8" : "var(--color-white)"}
      border={
        selected
          ? "2px solid var(--color-blue)"
          : "1px solid var(--color-grey-light)"
      }
      onClick={onClick}
      position="relative"
    >
      {isFreeTrial && (
        <Badge
          position="absolute"
          top={"-9px"}
          left="50%"
          transform="translateX(-50%)"
          bg="var(--color-blue)"
          color="white"
          borderRadius="full"
          textAlign={"center"}
          justifyContent={"center"}
          px={2}
          py={0}
          fontSize="var(--base-font-size-xs)"
          className="text-xs"
        >
          {freeTrialDays} DAYS FREE
        </Badge>
      )}
      <CardBody gap={2}>
        <Heading size="md" textAlign={"start"} fontSize="var(--base-font-size-xlarge)" className="text-xl">
          {heading}
        </Heading>
        <Text textAlign={"start"}>
          {getCurrencySymbol(currency)}
          {price}/week
        </Text>
      </CardBody>
      <Circle
        size="24px"
        border="2px solid"
        borderColor={selected ? "var(--color-blue)" : "var(--color-grey-light)"}
        position="relative"
        alignSelf={"center"}
      >
        {selected && (
          <CheckCircleIcon
            position="absolute"
            boxSize={6}
            color="var(--color-blue)"
          />
        )}
      </Circle>
    </Card>
  );
};

export default PremiumBlock;
